import { createApp } from 'vue';
import { sync } from 'vuex-router-sync/dist/vuex-router-sync.cjs';
import FontAwesomeIcon from '@/lib/FontAwesomeIcon';
import Highcharts from 'highcharts';
import Maps from 'highcharts/modules/map';
import heatmap from 'highcharts/modules/heatmap';
import treemap from 'highcharts/modules/treemap';
import histogram from 'highcharts/modules/histogram-bellcurve';
import exportingInit from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';
import accessibility from 'highcharts/modules/accessibility';
import HighchartsVue from 'highcharts-vue';
import vClickOutside from 'click-outside-vue3';
import store from '@/store';
import createRouter from '@/router';
import App from '@/App.vue';
import 'bootstrap';
import { tooltip } from '@/directives/tooltip';
import RollbarPlugin from '@/lib/rollbar';

const router = createRouter();

sync(store, router);

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
  credits: {
    enabled: true,
  },
});

Maps(Highcharts);
heatmap(Highcharts);
treemap(Highcharts);
histogram(Highcharts);
exportingInit(Highcharts);
exportData(Highcharts);
offlineExporting(Highcharts);
accessibility(Highcharts);

createApp(App)
  .use(RollbarPlugin)
  .use(FontAwesomeIcon)
  .use(HighchartsVue)
  .use(vClickOutside)
  .use(store)
  .use(router)
  .directive('tooltip', tooltip)
  .mount('#app');
